module.exports = __webpack_public_path__ + "img/pitching10.786bcb94.png";